import React from "react"
import ActivityBlock from "./ActivityBlock";

export default function JSAPreview({ activities, onUpdate, isDisabled, onDelete, onAdd, onMoveActivity, onMove, onDrop, likelihoods, consequences, riskRatings, onRiskSave }) {
  if (!activities || !activities.length) return null;

  let activityCount = 0;

  return (
    <>
      {activities.map((activity, actIndex) => {
        if (activity.toggled_active !== 1) return null;

        const displayIndex = activityCount;
        activityCount++;

        return (
          <ActivityBlock
            key={activity.id ? activity.id : `activity_${actIndex}`}
            activityDetails={activity}
            activityNumber={displayIndex + 1}
            actIndex={actIndex}
            onUpdate={onUpdate}
            isDisabled={isDisabled}
            onRiskSave={onRiskSave}
            onDelete={onDelete}
            onAdd={onAdd}
            onMoveActivity={onMoveActivity}
            onMove={onMove}
            onDrop={onDrop}
            likelihoods={likelihoods}
            consequences={consequences}
            riskRatings={riskRatings}
          />
        );
      })}
    </>
  );
}
